import { createI18n } from 'vue-i18n'
import en from './language/en.json'
import es from './language/es.json'

export default createI18n({
  locale: 'es',
  allowComposition: true,
  legacy: false,
  globalInjection: true,
  missingWarn: false,
  messages: {
    es: es,
    en: en
  }
})
